let _auth;
let _database = '';
if (typeof window !== `undefined`) 
{
    const firebase = require("firebase")

    var config = {
        apiKey: process.env.FIREBABE_API_KEY,
        authDomain: process.env.FIREBABE_AUTH_DOMAIN,
        databaseURL: process.env.FIREBABE_DATABASE_URL,
        projectId: process.env.FIREBABE_PROJECT_ID,
        storageBucket: process.env.FIREBABE_STORAGE_BUCKET,
        messagingSenderId: process.env.FIREBABE_MESSAGING_SENDER_ID
    };

    firebase.initializeApp(config);

    _auth = firebase.auth()
    _database = firebase.database();
}
 
export const Auth = _auth
export const Database = _database
